import type { User, UserRole } from '../types';

/** Renvoie l'ensemble des rôles d'un utilisateur (rôle principal + rôles additionnels). */
export function userRoles(user?: Partial<User> | null): string[] {
  if (!user) return [];
  if (user.all_roles && user.all_roles.length) return user.all_roles;
  const result: string[] = [];
  if (user.role) result.push(user.role);
  (user.roles || []).forEach((r) => { if (r && !result.includes(r)) result.push(r); });
  return result;
}

export function hasRole(user: Partial<User> | null | undefined, role: UserRole): boolean {
  return userRoles(user).includes(role);
}

export function hasAnyRole(user: Partial<User> | null | undefined, roles: UserRole[]): boolean {
  const r = userRoles(user);
  return roles.some((x) => r.includes(x));
}

export const ROLE_LABELS: Record<string, string> = {
  admin: 'Administrateur',
  dentist: 'Médecin/Dentiste',
  secretary: 'Secrétaire',
  comptable: 'Comptable',
};

export const ROLE_OPTIONS: { value: UserRole; label: string }[] = [
  { value: 'admin', label: 'Administrateur' },
  { value: 'dentist', label: 'Médecin/Dentiste' },
  { value: 'secretary', label: 'Secrétaire' },
  { value: 'comptable', label: 'Comptable' },
];
